import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/ai-commerce", label: "Why AI Readiness" },
  { to: "/pricing", label: "Pricing" },
  { to: "/autonomous-commerce", label: "AI Commerce" },
  { to: "/resources", label: "Resources" },
];

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-indigo-600 to-violet-600 flex items-center justify-center">
              <span className="text-white font-heading font-bold text-lg">A</span>
            </div>
            <span className="font-heading font-bold text-sm sm:text-base lg:text-lg text-slate-900 tracking-tight leading-none">Make My Business AI Ready <span className="text-indigo-600 font-semibold">(AgenticReady)</span></span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm font-medium text-slate-600 hover:text-indigo-600 transition-colors" data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            {user ? (
              <Button variant="ghost" onClick={() => navigate(user.role === "founder_admin" ? "/admin" : "/dashboard")} data-testid="nav-dashboard-btn" className="text-slate-700">
                Dashboard
              </Button>
            ) : (
              <Button variant="ghost" onClick={() => navigate("/login")} data-testid="nav-login-btn" className="text-slate-700">
                Log In
              </Button>
            )}
            <Button onClick={() => navigate("/free-scan")} data-testid="nav-scan-btn" className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-full px-5 font-semibold">
              Scan My Site Free
            </Button>
          </div>

          <button className="lg:hidden text-slate-700" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-slate-700 font-medium">{l.label}</Link>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            <Button variant="outline" onClick={() => { setOpen(false); navigate(user ? (user.role === "founder_admin" ? "/admin" : "/dashboard") : "/login"); }}>
              {user ? "Dashboard" : "Log In"}
            </Button>
            <Button onClick={() => { setOpen(false); navigate("/free-scan"); }} className="bg-indigo-600 text-white">Scan My Site Free</Button>
          </div>
        </div>
      )}
    </header>
  );
}
